<template>
  <div
    ref="frisbuy-widget-gallery"
    :class="{ 'frisbuy-widget': true, 'frisbuy-class': true, 'frisbuy-vertical': isVerticalGallery, [`frisbuy-layout-${ gallerySettings.layout }`]: gallerySettings.layout, [`frisbuy-${ settings.customerCode }`]:true}"
    :style="[galleryStyle]"
  >
    <!-- <script v-if="settings.popup.shareButtons.fb" src="https://connect.facebook.net/en_US/all.js" async="" type="application/javascript"></script> -->
    
    <div class="frisbuy-header">
      <div
        v-if="headerSettings.title || headerSettings.buttonTitle"
        class="frisbuy-title"
      >
        {{headerSettings.title}}
        <a v-if="headerSettings.buttonTitle" :href="headerSettings.buttonLink">
          {{headerSettings.buttonTitle}}
        </a>
      </div>

      <div v-if="headerSettings.subTitle" class="frisbuy-subtitle">{{headerSettings.subTitle}}</div>

      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>

      <div
        v-if="true || gallerySettings.layout == 'arrow' && ((isVerticalGallery && scrollTop > 0) || scrollWidth > 0)"
        class="frisbuy-gallery-navigation"
        :class="{ 'frisbuy-big': isLineRowsMode }"
      >
        <div
          class="frisbuy-navigation-button"
          :class="{'frisbuy-navigation-button-disabled': !canPrevScroll}"
          @click="slideHandler(-1)"
        >
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="16,24 8,16 16,8"/>
          </svg>
        </div>

        <div
          class="frisbuy-navigation-button"
          :class="{'frisbuy-navigation-button-disabled': !canNextScroll}"
          @click="slideHandler(1)"
        >
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24"/>
          </svg>
        </div>
      </div>
    </div>


    <div v-if="gallerySettings.filters.params" class="frisbuy-categories">
      <a
        v-for="filter in gallerySettings.filters.params"
        :href="`#tag=${filter.value ? filter.name : 'Все'}`"
        :class="{ 'frisbuy-category': true, 'frisbuy-active': filterValue == filter.value || (filterValue == null && !filter.value) }"
        @click="chosenFilter(filter)">{{filter.name}}</a>
    </div>


    <div class="frisbuy-gallery">
      <div
        v-touch:swipe="swipeHandler"
        class="frisbuy-scroll-wrapper"
        :class="{'no-scroll-width': !isVerticalGallery && scrollWidth < 0 }"
        :style="{} /*{ height: isVerticalGallery && gallerySettings.maxCols && `${ ((containerItemHeight + containerItemMargin) * gallerySettings.maxCols) }px`} */"
        ref="postsScroll"
      >
        <div :style="{} /*{ padding: isLineRowsMode && scrollWidth < 0 && `0 ${ containerItemMargin / 2}px` }*/">
          <ul
            class="frisbuy-gallery-posts frisbuy-gallery-posts__sheme-lazurit"
            id="frisbuy-gallery-posts"
            :class="{
              'frisbuy-gallery-multiline': isLineRowsMode,
              [`frisbuy-scheme-${ gallerySettings.scheme }`]: gallerySettings.layout == 'tile' && gallerySettings.scheme
            }"
            :style="{} /* { margin: `-${ containerItemMargin / 2}px`, width: `calc(100% + ${ containerItemMargin }px)`, maxHeight: !isVerticalGallery && isLineRowsMode && containerRowsHeight } */"
          >
            <template v-for="(post, index) in postList">
              <!-- <li v-if="gallerySettings.scheme && !isTablet && (index == 5 || !((index - 5) % 9))" class="frisbuy-divider"></li> -->

              <!-- <template v-if="post.frisbuyPost.type === 'advertising'"></template> -->
              <frisbuy-gallery-post
                v-if="isMobile || index >= startPostsIndex && index < endPostsIndex"
                :post="post"
                :key="post.frisbuyPost.id"
                :index="index"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :style="{} /*{width: getPostItemWidth(index), margin: `${ containerItemMargin / 2 }px` }*/"
                :observer="imageObserver"
                @click="clickPostHandler(post, index)"
                ref="postImage"
                >
            </frisbuy-gallery-post>
            </template>
          </ul>
        </div>

        <frisbuy-gallery-pagination
          :itemsCount="postList.length"
          :currentItemIdx="currentPostIndexInGalleryScrollWrapper"
          @navigateTo="(idx) => galleryScrollTo(idx)"
        />
      </div>
    </div>

    <div v-if="gallerySettings.branding" :class="[{'frisbuy-branding': true}, gallerySettings.branding ]">
      Сделано на
      <a :href="settings.brandingLink || ('https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign='+settings.customerCode)" rel="nofollow" target="_blank">
        <img :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`" alt="Frisbuy">
      </a>
    </div>


    <div class="frisbuy-footer">
      <div :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px'}" class="frisbuy-loadmore-button" v-if="gallerySettings.layout == 'tile' && gallerySettings.loadMore.enable && gallerySettings.loadMore.show" @click="loadMoreHandler">{{ gallerySettings.loadMore.text || 'Ещё' }}</div>
      <div v-if="gallerySettings.footer.html" v-html="gallerySettings.footer.html"></div>
    </div>
    

    <div v-if="gallerySettings.guideline.html && isGuidlineOpen" class="frisbuy-guideline">
      <div class="frisbuy-guideline-container">
        <div v-html="gallerySettings.guideline.html"></div>
      </div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="(direction) => selectPost(postList[currentPostIndex + direction], currentPostIndex + direction)"
    @close="() => closePopup()"
  />
</template>

<style src="./gallery.scss" lang="scss"></style>
<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import Popup from "../popup/popup.vue";
import FrsibuyGalleryScrollbar from "../components/FrisbuyGalleryScrollbar/FrisbuyGalleryScrollbar.vue";

export default {
  mixins: [defaultGallery],

  components: { 
    Popup,
    "frisbuy-gallery-scrollbar": FrsibuyGalleryScrollbar,
  },

  data() {
    return {
      countPostsPerPage: 4,
      startPostsIndex: 0,
      endPostsIndex: 4,

      scrollableGalleryQuerySelector: "#frisbuy-gallery-posts",
      galleryItemsQuerySelector: ".frisbuy-gallery-post",
      currentPostIndexInGalleryScrollWrapper: 0,
    };
  },

  computed: {
    isMobile: {
      cache: false,
      get() {
        return this.containerWidthPx <= 965;
      },
    },

    isTablet: {
      cache: false,
      get() {
        return this.containerWidthPx <= 965;
      },
    },
  },

  mounted() {
    const scrollableGallery = document.querySelector(
      this.scrollableGalleryQuerySelector
    );
    scrollableGallery.addEventListener("scroll", this.onScrollGallery);

    this.canPrevScroll = this.startPostsIndex > 0;
    this.canNextScroll = this.endPostsIndex < this.postList.length;
  },

  beforeUnmount() {
    const scrollableGallery = document.querySelector(
      this.scrollableGalleryQuerySelector
    );
    scrollableGallery.removeEventListener("scroll", this.onScrollGallery);
  },

  methods: {
    // [start] scroll mobile gallery
    onScrollGallery(e) {
      // const maxScroll = e.target.scrollWidth;
      const scrollLeft = e.target.scrollLeft;

      const scrollItemWidth =
        this.getGalleryFirstItemWidth() + this.getGalleryItemsMarginX();

      this.currentPostIndexInGalleryScrollWrapper = Math.round(
        scrollLeft / scrollItemWidth
      );
    },

    galleryScrollTo(itemIdx) {
      const scrollableGallery = document.querySelector(
        this.scrollableGalleryQuerySelector
      );

      const scrollItemWidth =
        this.getGalleryFirstItemWidth() + this.getGalleryItemsMarginX();

      scrollableGallery.scrollTo(scrollItemWidth * itemIdx, 0);
    },

    getGalleryFirstItemWidth() {
      const galleryFirstItem = document.querySelector(
        this.galleryItemsQuerySelector
      );

      return Number(galleryFirstItem.offsetWidth);
    },

    getGalleryItemsMarginX() {
      const galleryFirstItem = document.querySelectorAll(
        this.galleryItemsQuerySelector
      )[0];
      const gallerySecondItem = document.querySelectorAll(
        this.galleryItemsQuerySelector
      )[1];

      const marginOfFirstItem = this.getTranslatePxToNumber(
        window.getComputedStyle(galleryFirstItem).marginRight
      );
      const marginOfSecondItem = this.getTranslatePxToNumber(
        window.getComputedStyle(gallerySecondItem).marginLeft
      );

      const marginBetweenItems = marginOfFirstItem + marginOfSecondItem;

      return Number(marginBetweenItems);
    },

    getTranslatePxToNumber(stringInPx) {
      const pxSymbolsAmount = 2;

      return stringInPx.slice(0, stringInPx.length - pxSymbolsAmount);
    },
    // [end] scroll mobile gallery

    slideHandler(direction) {
      let startIndex =
        this.startPostsIndex + this.countPostsPerPage * direction;
      let endIndex = this.endPostsIndex + this.countPostsPerPage * direction;

      if (startIndex < 0) {
        this.startPostsIndex = 0;
        this.endPostsIndex = this.countPostsPerPage;
      } else if (endIndex >= this.postList.length) {
        this.startPostsIndex = startIndex;
        this.endPostsIndex = this.postList.length - 1;
      } else {
        this.startPostsIndex = startIndex;
        this.endPostsIndex += this.countPostsPerPage * direction;
      }

      this.canPrevScroll = this.startPostsIndex > 0;
      this.canNextScroll = endIndex < this.postList.length;
    },

    arrowScrollHandler() {
      // HACK: this emty func for to avoid `defaultGallery` mixin
      return;
    },
  },
};
</script>
